module.exports = __webpack_public_path__ + "img/about_header4.756d0166.png";